<template>
  <div
    v-if="hasFavourites"
    id="favourite-event-icon"
    class="header-right__favourite"
  >
    <a
      v-if="isLoggedIn"
      href="/mina-favourite-events"
      class="header-favourite__wrapper"
      aria-label="favourite icon (login required)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="heart-icon heart-icon-black"
        width="24"
        height="24"
        fill="#ff00ff"
        stroke="#ff00ff"
        stroke-width="2"
        viewBox="0 0 24 24"
      >
        <path
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5
          2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81
          4.5 2.09C13.09 3.81 14.76 3 16.5 3
          19.58 3 22 5.42 22 8.5c0 3.78-3.4
          6.86-8.55 11.54L12 21.35z"
        />
      </svg>
      <span class="header-favourite__count">{{ totalFavourites }}</span>
    </a>
    <button
      v-else
      id="favourite-modal-id"
      @click="openFavouriteModal"
      class="header-favourite__wrapper"
      aria-label="favourite icon"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="heart-icon heart-icon-black"
        width="24"
        height="24"
        fill="#ff00ff"
        stroke="#ff00ff"
        stroke-width="2"
        viewBox="0 0 24 24"
      >
        <path
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5
            2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81
            4.5 2.09C13.09 3.81 14.76 3 16.5 3
            19.58 3 22 5.42 22 8.5c0 3.78-3.4
            6.86-8.55 11.54L12 21.35z"
        />
      </svg>

      <span class="header-favourite__count">{{ totalFavourites }}</span>
    </button>

    <!-- Favourites Modal -->
    <div
      id="favourite-modal-box"
      class="header-favourite__modal"
      v-if="isFavouriteModalVisible"
      @click.self="closeFavouriteModal"
    >
      <div class="favourite-modal__content">
        <span
          id="favourite-modal-close-button"
          class="header-favourite__modal--close"
          @click="closeFavouriteModal"
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                fill="#000000"
              ></path>
            </g>
          </svg>
        </span>
        <h2>Hittat en favorit?</h2>
        <p>
          Logga in eller skapa ett konto för att se och spara dina
          favoritevenemang.
        </p>
        <a
          href="https://tix.kulturhusetstadsteatern.se/sv/login/?ReturnUrl=https://kulturhusetstadsteatern.se/login-redirect"
          class="favourite-modal__link"
          >Logga in/Skapa konto</a
        >
      </div>
    </div>

    <!-- Modal Overlay -->
    <div
      id="favourite-modal-box-overlay"
      class="favourite-modal__overlay"
      v-if="isFavouriteModalVisible"
      @click="closeFavouriteModal"
    ></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "FavouriteIcon",
  data() {
    return {
      isLoggedIn: false,
      isFavouriteModalVisible: false,
    };
  },
  methods: {
    ...mapActions([
      "updateFavouriteEventIds",
      "fetchFavouriteIdsFromDB"
    ]),
    openFavouriteModal() {
      this.isFavouriteModalVisible = true;
    },
    closeFavouriteModal() {
      this.isFavouriteModalVisible = false;
    },
  },
  computed: {
    ...mapGetters(["hasFavourites", "totalFavourites"]),
  },
  mounted() {

    this.isLoggedIn = localStorage.getItem("loggedInFavouriteCheck") === "true";

    if (this.isLoggedIn) {
      this.fetchFavouriteIdsFromDB().then((hasDbData) => {
        if (!hasDbData) {
          this.updateFavouriteEventIds();
        }
      });
    } else {
      this.updateFavouriteEventIds();
    }

  },
};
</script>

<style lang="scss">
@import "web/themes/custom/khst_theme/_sass-config/sass-config";

.header-right {
  &__favourite {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;

    .heart-icon {
      stroke: $magenta;
      transition: fill 0.3s ease;
    }

    svg {
      margin: 0rem 1rem;
      width: 1.5rem;
      height: 1.5rem;

      .outlined {
        fill: none;
        stroke: black;
        stroke-width: 1.5;
      }
      .filled {
        fill: black;
        stroke: none;
      }
    }
  }
}

.header-favourite {
  &__wrapper {
    position: relative;
    background: transparent;
    border: 0px;
  }

  &__count {
    position: absolute;
    top: -10px;
    right: 10px;
    font-size: 0.75rem;
    font-weight: 700;
    color: $black;
  }

  &__modal {
    position: fixed;
    top: 30%;
    left: 0;
    transform: translate(0%, -50%);
    background-color: $white;
    border: 2px $black solid;
    margin: 0 1rem;
    z-index: 999;
    width: 93%;

    @media (min-width: 550px) {
      width: 95%;
    }

    @media (min-width: 728px) {
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      min-width: 30rem;
      width: unset;
    }

    &--close {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 20px;
      font-weight: bold;
      cursor: pointer;

      svg {
        margin: 1rem;
      }
    }
  }
}

.favourite-modal {
  &__content {
    display: flex;
    flex-direction: column;
    margin: 1.5rem;
    margin-top: 2.5rem;
  }

  &__link {
    background-color: $black;
    color: $white;
    font-weight: 700;
    text-transform: uppercase;
    text-decoration: none;
    width: fit-content;
    margin-top: 3rem;
    margin-left: auto;
    padding: 0.5rem;

    &:hover {
      text-decoration: underline;
    }
  }

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
}

.mobile-menu-open {
  #favourite-event-icon {
    @media (max-width: 1150px) {
      svg {
        fill: $magenta;
        stroke: $magenta;
      }

      .header-favourite__count {
        color: $white;
      }
    }
  }
}
</style>
